/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, string,
} from 'prop-types';
import Media from 'react-media';
import mbpLogger from 'mbp-logger';
import { GRAPHQL_ENV } from '../../../../gql';
import SimpleProduct from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/GraphqlSimpleProduct';
import { getUserSubmittedProductFilterZipcode, getLocationType } from '../../../../../state/ducks/App/App-Selectors';
import * as app from '../../../../../state/ducks/App';

const brandSelectors = app.ducks.brand.selectors;

const styles = () => ({
    simpleProduct: {
        flex: '0 0 33.333333%',
        marginBottom: '30px',
        maxWidth: '33.333333%',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
    },
    productRow: {
        boxSizing: 'border-box',
        marginRight: '-10px',
        marginLeft: '-10px',
        width: 'auto',
    },
    simpleProduct4row: {
        flex: '0 0 25%',
        marginBottom: '30px',
        maxWidth: '25%',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
    },
    simpleProduct3row: {
        margin: '0 5px 10px',
        maxWidth: 'calc(33% - 10px)',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
    },
});

const ProductListingAdCategoryContainer = ({
    brand, classes, categoryId,
}) => {
    const CATEGORY_PRODUCT_QUERY = gql`
        query CategoryProductQuery {
            findCategoryById(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", id:"${categoryId}", locale: "en-us") {
                products {
                id
                image {
                    altText
                    name
                    path
                    snipeImagePath
                    snipe
                    path
                }
                partNumber
                prices {
                    currency
                    type
                    value
                }
                skuPriceRange {
                    sale {
                        value
                    }
                    retail {
                        value
                    }
                }
                name
                brand
                seo {
                    url
                }
                availability {
                    availabilityIndicator
                    deliveryDateType
                    displayEndDate
                    displayStartDate
                    earliestShipDate
                    latestShipDate
                    perishable
                    productDeliveryType
                    shipAlone
                    deliveryMessage
                }
            }
        }
    }
`;

    return (
        <Query query={CATEGORY_PRODUCT_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null;
                }

                if (error) {
                    mbpLogger.logError({
                        query: CATEGORY_PRODUCT_QUERY,
                        component: 'ProductListingAdCategoryContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: CATEGORY_PRODUCT_QUERY,
                        component: 'ProductListingAdCategoryContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                let productData = [];
                if (data && data.findCategoryById !== null && data.findCategoryById.products !== null) {
                    productData = data.findCategoryById.products;
                }

                return (
                    <>
                        <Media
                            query="(max-width: 600px)"
                        >
                            {(matches) => (matches ? (
                                <Grid container className={classes.productRow}>
                                    {productData.length !== 0
                                        ? productData.map((product) => {
                                            const {
                                                name, image, seo: { url }, skuPriceRange, availability,
                                            } = product;
                                            return (
                                                <Grid item key={product.name} className={classes.simpleProduct3row}>
                                                    {/* for the product not available flow we need to know whether the simple product component was rendered on a category page vs the homepage or any other location */}
                                                    {/* to do this we check whether the product container got categoryData as opposed to some other kind of graphql data */}
                                                    <SimpleProduct name={name} image={image} url={url} skuPriceRange={skuPriceRange} availability={availability} fromCategoryPage={typeof categoryData === 'object'} categoryId={categoryId} brand={brand} />
                                                </Grid>
                                            );
                                        })
                                        : null}
                                </Grid>
                            ) : (
                                <Grid container className={classes.productRow}>
                                    {productData.length !== 0
                                        ? productData.map((product) => {
                                            const {
                                                name, image, seo: { url }, skuPriceRange, availability,
                                            } = product;
                                            return (
                                                <Grid item key={product.name} className={classes.simpleProduct4row}>
                                                    {/* for the product not available flow we need to know whether the simple product component was rendered on a category page vs the homepage or any other location */}
                                                    {/* to do this we check whether the product container got categoryData as opposed to some other kind of graphql data */}
                                                    <SimpleProduct name={name} image={image} url={url} skuPriceRange={skuPriceRange} availability={availability} fromCategoryPage={typeof categoryData === 'object'} categoryId={categoryId} brand={brand} />
                                                </Grid>
                                            );
                                        })
                                        : null}
                                </Grid>
                            ))}
                        </Media>
                    </>
                );
            }}
        </Query>
    );
};

ProductListingAdCategoryContainer.propTypes = {
    classes: object.isRequired,
    categoryId: string.isRequired,
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
    locationType: getLocationType(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
});

export default connect(mapStateToProps)(withStyles(styles)(ProductListingAdCategoryContainer));
